import React, { lazy, Suspense } from 'react'
import { LoyaltyCardType, LoyaltyRewardType, StoreType } from './types'
import Spin from 'antd/lib/spin'
import { StyledDrawer } from 'components/Common'

interface LoyaltyDrawerProps {
  activeCard: LoyaltyCardType | null
  activeRewards: LoyaltyRewardType[]
  stores: StoreType[]
  visible: boolean
  onClose: () => void
  onDrawerClose: () => void
}

const LoyaltyCardForm = lazy(() => import('./LoyaltyCardForm'))

const LoyaltyDrawer = (props: LoyaltyDrawerProps) => {
  const { activeCard, activeRewards, onClose, onDrawerClose, stores, visible } =
    props

  return (
    <StyledDrawer
      onClose={onClose}
      open={visible}
      className='order-drawer'
      title='Loyalty Card Settings'
      destroyOnClose={true}
    >
      <Suspense fallback={<Spin />}>
        <LoyaltyCardForm
          activeCard={activeCard}
          activeRewards={activeRewards}
          stores={stores}
          onDrawerClose={onDrawerClose}
        />
      </Suspense>
    </StyledDrawer>
  )
}

export default LoyaltyDrawer
